import * as actionTypes from '../types/stock';

const initialState = {
  error: false,
  file: {
    loading: false,
    status: null
  },
  listStocks: [],
  loading: false,
  selectPlantId: null,
  stockOptions: {},
  storageTime: {
    data: null,
    error: false,
    loading: false
  }
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.FETCH_STOCK:
      return {
        ...state,
        error: false,
        loading: true
      };

    case actionTypes.FETCH_STOCK_SUCCESS:
      return {
        ...state,
        listStocks: payload,
        error: false,
        loading: false
      };

    case actionTypes.FETCH_STOCK_FAIL:
      return {
        ...state,
        loading: false,
        error: payload
      };

    case actionTypes.FETCH_STOCK_OPTIONS:
      return {
        ...state,
        error: false,
        loading: true
      };

    case actionTypes.FETCH_STOCK_OPTIONS_SUCCESS:
      return {
        ...state,
        stockOptions: payload,
        error: false,
        loading: false
      };

    case actionTypes.FETCH_STOCK_OPTIONS_FAIL:
      return {
        ...state,
        loading: false,
        error: payload
      };

    case actionTypes.SELECT_PLANT_ID:
      return {
        ...state,
        selectPlantId: payload
      };

    case actionTypes.GET_SETTINGS_PLANT_STORAGE_TIME:
      return {
        ...state,
        storageTime: {
          ...state.storageTime,
          error: false,
          loading: true
        }
      };
    case actionTypes.GET_SETTINGS_PLANT_STORAGE_TIME_SUCCESS:
      return {
        ...state,
        storageTime: {
          ...state.storageTime,
          data: payload,
          loading: false
        }
      };
    case actionTypes.GET_SETTINGS_PLANT_STORAGE_TIME_FAIL:
      return {
        ...state,
        storageTime: {
          ...state.storageTime,
          error: true,
          loading: false
        }
      };
    case actionTypes.SET_SETTINGS_PLANT_STORAGE_TIME:
      return {
        ...state,
        storageTime: {
          ...state.storageTime,
          error: false,
          loading: true
        }
      };
    case actionTypes.SET_SETTINGS_PLANT_STORAGE_TIME_SUCCESS:
      return {
        ...state,
        storageTime: {
          ...state.storageTime,
          data: payload,
          loading: false
        }
      };
    case actionTypes.SET_SETTINGS_PLANT_STORAGE_TIME_FAIL:
      return {
        ...state,
        storageTime: {
          ...state.storageTime,
          error: true,
          loading: false
        }
      };

    case actionTypes.SEND_FILE_STOCK_SETTINGS:
      return {
        ...state,
        file: {
          ...state.file,
          loading: true
        }
      };
    case actionTypes.SEND_FILE_STOCK_SETTINGS_SUCCESS:
      return {
        ...state,
        file: {
          ...state.file,
          loading: true
        }
      };
    case actionTypes.SEND_FILE_STOCK_SETTINGS_FAIL:
      return {
        ...state,
        file: {
          ...state.file,
          loading: false
        }
      };

    case actionTypes.STATUS_FILE_STOCK_SETTINGS_SUCCESS:
      return {
        ...state,
        file: {
          ...state.file,
          loading: false
        }
      };
    case actionTypes.STATUS_FILE_STOCK_SETTINGS_FAIL:
      return {
        ...state,
        file: {
          ...state.file,
          loading: false
        }
      };

    default:
      return state;
  }
};

export default reducer;
